export const WINDOW_KEY = 'commonQueue';
